"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./components/Slider/index'));

//# sourceMappingURL=Slider.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./Slider.js
 ** module id = 243
 ** module chunks = 0
 **/